exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".basic-form-container[data-v-58f9e903]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:20px}.basic-form-container .left-section[data-v-58f9e903],.basic-form-container .right-section[data-v-58f9e903]{-webkit-box-flex:1;-ms-flex:1;flex:1}.basic-form-container .full-width[data-v-58f9e903]{width:100%}.basic-form-container .tourist-tip[data-v-58f9e903]{margin-left:50px;color:#ff4d4f;font-size:12px}", ""]);

// exports
